/**
 * Extracts the exact validation error message from bulk upload API error response.
 * API returns: { errors: { title, description: { code, errors: [{ key, message, path }] }, link } }
 * Accepts: axios error (err.response.data) OR direct response object (when API returns 200 with error payload)
 */
export default function getBulkUploadErrorMessage(errOrResponse) {
    if (!errOrResponse) return null;

    let data = errOrResponse?.response?.data ?? errOrResponse;
    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        } catch {
            return data || errOrResponse?.message;
        }
    }
    if (!data) return errOrResponse?.message || null;

    // Path 1: errors.description.errors (validation errors array)
    const desc = data?.errors?.description ?? data?.description;
    const errorsArray = Array.isArray(desc?.errors) ? desc.errors : [];

    if (errorsArray.length > 0) {
        const parts = errorsArray.map((e) => e?.message?.trim()).filter(Boolean);
        return parts.join('.\n');
    }

    // Path 2: errors.description as string (specific message, e.g. CSV_QUOTE_CHAR_INVALID)
    if (typeof desc === 'string' && desc.trim()) return desc.trim();

    // Path 3: errors.title or flat message
    if (data?.errors?.title) return data.errors.title;
    if (data?.message) return data.message;
    if (errOrResponse?.message) return errOrResponse.message;

    return null;
}
